export const groupStories = stories => {
	return stories.reduce((acc, story) => {
		const year = new Date(story.node.createdAt).getFullYear();
		return {
			...acc,
			[year]: [...(acc[year] ?? []), story],
		};
	}, {});
};
